import { Link, NavLink, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";
import { LOGO_URL } from "@/lib/constants";

const NAV = [
  { to: "/", label: "Home" },
  { to: "/storia", label: "Storia" },
  { to: "/menu", label: "Menu" },
  { to: "/galleria", label: "Galleria" },
  { to: "/contatti", label: "Contatti" },
];

export default function Header() {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  return (
    <header
      className="relative z-40 border-b border-ink/90 bg-paper"
      data-testid="site-header"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-16">
        <div className="flex items-center justify-between py-5 md:py-7">
          {/* Left mark */}
          <Link
            to="/"
            className="flex items-center gap-3"
            data-testid="header-logo-link"
          >
            <img
              src={LOGO_URL}
              alt="Stemma Pedrocchi"
              className="h-12 md:h-14 w-auto"
            />
            <div className="hidden sm:block leading-tight">
              <div className="font-serif text-xl md:text-2xl tracking-tight">
                Pedrocchi
              </div>
              <div className="font-mono text-[0.6rem] tracking-[0.3em] uppercase text-ink-mid">
                Venezia · Dal 1971
              </div>
            </div>
          </Link>

          {/* Desktop nav */}
          <nav className="hidden lg:flex items-center gap-8" aria-label="Principale">
            {NAV.map((n) => (
              <NavLink
                key={n.to}
                to={n.to}
                end={n.to === "/"}
                className={({ isActive }) =>
                  `nav-link ${isActive ? "active" : ""}`
                }
                data-testid={`nav-${n.label.toLowerCase()}`}
              >
                {n.label}
              </NavLink>
            ))}
            <Link
              to="/prenotazioni"
              className="btn-primary !py-2 !px-5"
              data-testid="nav-book-cta"
            >
              Prenota
            </Link>
          </nav>

          {/* Mobile toggle */}
          <button
            type="button"
            aria-label={open ? "Chiudi menu" : "Apri menu"}
            onClick={() => setOpen((s) => !s)}
            className="lg:hidden p-2 -mr-2 text-ink"
            data-testid="mobile-menu-toggle"
          >
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      {open && (
        <div
          className="lg:hidden border-t border-ink bg-paper-dark"
          data-testid="mobile-menu"
        >
          <div className="max-w-7xl mx-auto px-6 py-6 flex flex-col gap-5">
            {NAV.map((n) => (
              <NavLink
                key={n.to}
                to={n.to}
                end={n.to === "/"}
                className={({ isActive }) =>
                  `nav-link inline-block ${isActive ? "active" : ""}`
                }
                data-testid={`mobile-nav-${n.label.toLowerCase()}`}
              >
                {n.label}
              </NavLink>
            ))}
            <Link
              to="/prenotazioni"
              className="btn-primary text-center mt-2"
              data-testid="mobile-nav-book-cta"
            >
              Prenota
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}
